const initialValues = {
  email: "",
  password: "",
  confirmPassword: "",
};

export default initialValues;
